export default __webpack_public_path__ + "static/media/331.bec40181.jpg";